import { render } from "./Trade.vue?vue&type=template&id=54b436ba&scoped=true"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"

import "./Trade.vue?vue&type=style&index=0&id=54b436ba&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b436ba"]])

export default __exports__